import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-lg-500px bg-white rounded shadow-sm p-10 p-lg-15 mx-auto"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mb-10" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-dark mb-3" }, "Sign In")
], -1)
const _hoisted_3 = { class: "mb-10 rounded" }
const _hoisted_4 = { class: "fv-row mb-10" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-6 fw-bolder text-dark" }, "Email", -1)
const _hoisted_6 = { class: "fv-plugins-message-container" }
const _hoisted_7 = { class: "fv-help-block" }
const _hoisted_8 = { class: "fv-row mb-10" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-stack mb-2" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6 mb-0" }, "Password")
], -1)
const _hoisted_10 = { class: "fv-plugins-message-container" }
const _hoisted_11 = { class: "fv-help-block" }
const _hoisted_12 = { class: "text-center" }
const _hoisted_13 = ["disabled", "data-kt-indicator"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Continue ", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = {
  key: 1,
  class: "w-lg-600px bg-body rounded shadow-sm p-10 p-lg-15 mx-auto"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mb-10" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "Logo",
    class: "mh-125px",
    src: "/media/svg/misc/smartphone.svg"
  })
], -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mb-10" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-dark mb-3" }, "Two Step Verification"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-muted fw-bold fs-5 mb-5" }, "Enter the verification code we sent to")
], -1)
const _hoisted_20 = { class: "mb-10 px-md-10" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder text-start text-dark fs-6 mb-1 ms-1" }, "Type your 6 digit security code", -1)
const _hoisted_22 = { class: "mb-10 rounded" }
const _hoisted_23 = { class: "d-flex flex-wrap flex-stack" }
const _hoisted_24 = { class: "fv-plugins-message-container" }
const _hoisted_25 = { class: "fv-help-block" }
const _hoisted_26 = { class: "d-flex flex-center pt-3" }
const _hoisted_27 = ["disabled", "data-kt-indicator"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, "Submit", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode("Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_30 = [
  _hoisted_28,
  _hoisted_29
]
const _hoisted_31 = /*#__PURE__*/_createStaticVNode("<div class=\"text-center fw-bold fs-5\"><span class=\"text-muted me-1\">Didn’t get the code ?</span><a href=\"javascript:void (0);\" class=\"link-primary fw-bolder fs-5 me-1\">Resend</a><span class=\"text-muted me-1\">or</span><a href=\"javascript:void (0);\" class=\"link-primary fw-bolder fs-5\">Call Us</a></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Error = _resolveComponent("Error")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.verifyCode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_Form, {
            class: "form w-100",
            onSubmit: _ctx.onSubmitLogin,
            "validation-schema": _ctx.login
          }, {
            default: _withCtx(() => [
              _hoisted_2,
              _createElementVNode("div", _hoisted_3, [
                (_ctx.signError.isError)
                  ? (_openBlock(), _createBlock(_component_Error, {
                      key: 0,
                      show: "true",
                      message: _ctx.signError.message
                    }, null, 8, ["message"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createVNode(_component_Field, {
                  class: "form-control form-control-lg form-control-solid",
                  type: "text",
                  name: "email",
                  modelValue: _ctx.state.email,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.email) = $event)),
                  autocomplete: "off"
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_ErrorMessage, { name: "email" })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(_component_Field, {
                  class: "form-control form-control-lg form-control-solid",
                  type: "password",
                  modelValue: _ctx.state.password,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.password) = $event)),
                  name: "password",
                  autocomplete: "off"
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_ErrorMessage, { name: "password" })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("button", {
                  type: "submit",
                  disabled: _ctx.loginSubmitting,
                  "data-kt-indicator": _ctx.loginSubmitting ? 'on':'',
                  class: "btn btn-lg btn-primary w-100 mb-5"
                }, _hoisted_16, 8, _hoisted_13)
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.verifyCode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createVNode(_component_Form, {
            class: "form w-100 mb-10",
            "validation-schema": _ctx.verify,
            onSubmit: _ctx.onCodeSubmit
          }, {
            default: _withCtx(() => [
              _hoisted_18,
              _hoisted_19,
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _createElementVNode("div", _hoisted_22, [
                  (_ctx.signError.isError)
                    ? (_openBlock(), _createBlock(_component_Error, {
                        key: 0,
                        show: "true",
                        message: _ctx.signError.message
                      }, null, 8, ["message"]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createVNode(_component_Field, {
                    class: "form-control form-control-lg form-control-solid",
                    type: "text",
                    name: "code",
                    modelValue: _ctx.state.code,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.code) = $event)),
                    autocomplete: "off"
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _createVNode(_component_ErrorMessage, { name: "code" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("button", {
                    type: "submit",
                    disabled: _ctx.verifySubmitting,
                    "data-kt-indicator": _ctx.verifySubmitting ? 'on':'',
                    class: "btn btn-lg btn-primary fw-bolder"
                  }, _hoisted_30, 8, _hoisted_27)
                ])
              ])
            ]),
            _: 1
          }, 8, ["validation-schema", "onSubmit"]),
          _hoisted_31
        ]))
      : _createCommentVNode("", true)
  ], 64))
}